import { render, staticRenderFns } from "./productionDetail.vue?vue&type=template&id=e41081b6&scoped=true"
import script from "./productionDetail.vue?vue&type=script&lang=js"
export * from "./productionDetail.vue?vue&type=script&lang=js"
import style0 from "../../../style/exchange-shop/m/common.scss?vue&type=style&index=0&id=e41081b6&prod&lang=scss&scoped=true&external"
import style1 from "./productionDetail.vue?vue&type=style&index=1&id=e41081b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e41081b6",
  null
  
)

export default component.exports